import Vue from "vue";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ro";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI, { locale });
